<template>
  <button class="cta" :class="typeClass" @click="submit" :disabled="disabled">
    <slot name="content">
      <span v-if="label" class="label">{{ label }}</span>
      <icon v-if="icon" :icon="icon" size="sm" />
      <span v-if="subtitle" class="subtitle">{{ subtitle }}</span>
    </slot>
  </button>
</template>

<script>
import Icon from '../../../templates/vue-elements/icon/Icon.vue';
export default {
  components: { Icon },
  name: 'k-button',
  props: {
    label: String,
    icon: String,
    subtitle: String,
    disabled: {
      required: false,
      type: Boolean,
      default: false,
    },
    type: {
      required: false,
      type: String,
      default: 'icon-right',
      validator: (value) =>
        [
          'icon-right',
          'icon-left',
          'icon-only',
          'no-icon',
          'vertical',
          'subtitle',
          'extra-large',
        ].includes(value),
    },
  },
  methods: {
    submit() {
      this.$emit('submit');
    },
  },
  computed: {
    typeClass() {
      return `cta-${this.type}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@use 'abstracts_depr/elements/button/button';

.cta {
  &.cta-icon-right {
    @include button.cta-icon-right;
  }
  &.cta-icon-left {
    @include button.cta-icon-left;
  }
  &.cta-no-icon {
    @include button.cta-no-icon;
  }
  &.cta-icon-only {
    @include button.cta-icon-only;
  }
  &.cta-vertical {
    @include button.cta-vertical;
  }
  &.cta-subtitle {
    @include button.cta-subtitle;
  }
  &.cta-extra-large {
    @include button.cta-extra-large;
  }

  &:disabled {
    @include button.cta-disabled;
  }
}
</style>
